import axios from "axios";
import Vue from "vue";
axios.defaults.baseURL = process.env.VUE_APP_BASE_API;


const state = () => ({
    activeModals: [],
    //TO-DO keep active modals in state
})

const getters = {
    activeModals: state => state.activeModals,
}
// actions
const actions = {
    // eslint-disable-next-line no-unused-vars
}

// mutations
const mutations = {
    // eslint-disable-next-line no-unused-vars
    openModal(state, {modalName, modal, parent, props, data}) {
        let ModalConstructor;
        let modalInstance;
        ModalConstructor = Vue.extend(modal);
        modalInstance = new ModalConstructor({parent});
        if(props){
            Array.from(Object.keys(props)).forEach( key => {
                modalInstance[key] = props[key];
            })
        }
        modalInstance.$mount();
        modalInstance.openModal(data);
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
